import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SearchUI from '../../../widgets/input/SearchUI'
import ProgressUI from '../../../widgets/output/ProgressUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonLinkUI from '../../../widgets/action/IconButtonLinkUI'
import './OrderList.css'

const OrderListUI = ({context, messageList, orderList,
    alphaSort, timeSort, searchFilter, statusList, onStatusFilterChange, statusFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick,
    onSearchFilterChange
  }) =>
  <div className='ord_orders'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onStatusFilterChange={onStatusFilterChange}
          statusFilter={statusFilter}
          statusList={statusList}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        orderList.map((order, i) =>
          <OrderRowUI key={i} context={context} order={order} messageList={messageList} />
        )
      }
    </LRTableBodyUI>
  </div>

const OrderRowUI = ({context, order, messageList}) =>
  <LRTableRowLinkUI
    context={context}
    to={`/orders/${order.id}/items`}
    left={<RowLeftUI context={context} order={order} messageList={messageList} />}
    right={<RowRightUI context={context} order={order} />}
  />

const RowLeftUI = ({context, order, messageList}) =>
  <div>
    <div className='g_small'>
      {order.customerName}
    </div>
    <div>
      {order.estimateName}
    </div>
    <div className='g_m_top_50'>
      {
        order.status === 'open' && order.dueDateF1 &&
        <LabelAndValueUI messageList={messageList} labelKey='c_due_date'>
          <div className='g_small'>{order.dueDateF1}</div>
        </LabelAndValueUI>
      }
      {
        order.status === 'done' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_completion_date'>
          <div className='g_small g_flex_h date_badge'>
            {order.doneDateF1}
            <div className='g_m_left_100'>
              <BadgeUI messageList={messageList} labelKey='c_status_done' />
            </div>
          </div>
        </LabelAndValueUI>
      }
      {
        order.status === 'cancelled' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_cancel_date'>
          <div className='g_small g_flex_h date_badge'>
            {order.cancelDateF1}
            <div className='g_m_left_100'>
              <BadgeUI messageList={messageList} labelKey='c_cancelled' />
            </div>
          </div>
        </LabelAndValueUI>
      }
    </div>
  </div>

const RowRightUI = ({context, order}) =>
  <div className='g_flex_v g_text_right'>
    {/*<ProgressUI percent={order.itemsDonePercent} alarm={order.behindSchedule}/>*/}
    <div>{order.estimateTotalF2}</div>
  </div>

const ActionLeftUI = ({context, messageList, alphaSort, timeSort,
    onRefreshClick, onAlphaSortClick, onTimeSortClick
  }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonLinkUI messageList={messageList} icon='icon-plus' to='/orders/create' labelKey='c_create_order' />
    }
    <IconButtonUI messageList={messageList} icon='icon-sort-alpha-asc' selected={alphaSort} onClick={onAlphaSortClick} labelKey='c_sort_alpha' />
    <IconButtonUI messageList={messageList} icon='icon-clock-o' selected={timeSort} onClick={onTimeSortClick} labelKey='c_sort_time' />
  </div>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange,
    statusList, onStatusFilterChange, statusFilter
  }) =>
  <div className='g_flex_h'>
    <SelectSingleSF messageList={messageList} optionList={statusList} onChange={onStatusFilterChange}
      selectedKey={statusFilter} removeKey='c_all'
    />
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default OrderListUI
